<template>
    <div style="padding:10px;">
        <div v-if="order" style="background:#fff;">
            <table class="order-list" style="width:100%; font-size: 12px;" cellspacing="0" cellpadding="0">
                <tr class="order-header" v-bind:key="order.id">
                    <td colspan="3">
                        <div class="col-md-4 order-text">{{ $t('pages.cancellation.order_time') }}:
                            {{ getLocalDateString(order.locale, order.created_at, 'short') }}
                            {{ getLocalTimeString(order.locale, order.created_at) }}</div>
                        <div class="col-md-4 order-text">{{ $t('pages.cancellation.booking_number') }}:
                            {{ order.booking_number }}</div>
                        <div class="col-md-4 order-text"></div>
                        <div v-if="order.status == 'cancelled'" class="col-md-3 order-text">
                            {{ $t('pages.cancellation.status') }}: {{ $t('pages.cancellation.cancelled') }}
                        </div>
                    </td>
                </tr>
                <template class="leg" v-for="leg in order.legs">
                    <tr v-bind:key="leg.id">
                        <td colspan="3" style="background-color: #f1f1f1;">
                            <span style="margin-right:10px; font-weight:bold;">{{ getDateString(order.locale,
                                leg.steps[0].transit.local_depart_at, 'long') }}</span>
                            <span>{{ getWeekday(order.locale, leg.steps[0].transit.local_depart_at) }}</span>
                        </td>
                    </tr>
                    <template v-for="(step, stepIndex) in leg.steps">
                        <tr class="transit" v-if="step.travel_mode == 'transit'" v-bind:key="step.id">
                            <td>
                                <span>{{ getLocalDateString(order.locale, step.transit.depart_at, 'short')
                                }}</span>&nbsp;
                                <span style="font-weight:bold;">{{ getLocalTimeString(order.locale,
                                    step.transit.depart_at) }}</span>&nbsp;
                                <span style="display:inline-block">{{ step.transit.departure_stop.name }}</span>
                            </td>
                            <td>
                                <span>{{ getLocalDateString(order.locale, step.transit.arrive_at, 'short')
                                }}</span>&nbsp;
                                <span style="font-weight:bold;">{{ getLocalTimeString(order.locale,
                                    step.transit.arrive_at) }}</span>&nbsp;
                                <span style="display:inline-block">{{ step.transit.arrival_stop.name }}</span>
                            </td>
                            <td v-if="stepIndex == 0 && order.status != 'cancelled'" v-bind:rowspan="leg.steps.length">
                                <form-input type="checkbox" v-model="leg.selected" v-bind:disabled="!ableToCancel(leg)"
                                    v-bind:label="$t('pages.cancellation.select')"></form-input>

                            </td>
                        </tr>
                    </template>
                </template>
            </table>
            <div v-if="!loading && order && order.status != 'cancelled'" class="n2-margin-top n2-text-right">
                <button class="n2-button-1" v-on:click="cancelBooking">{{ $t('pages.cancellation.cancel_selected')
                }}</button>
            </div>
        </div>
        <div v-if="responded">
            <div v-if="result_error" class="n2-margin-top">
                <result-summary v-bind:error="result_error"></result-summary>
            </div>
            <h4 v-else>{{ $t('pages.cancellation.success') }}</h4>
        </div>
        <app-loader v-bind:active="loading"></app-loader>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { OrderService, EmailService } from '../../services'

import AppLoader from '../../components/shared/loader.vue';
import FormInput from '../../components/shared/form-input.vue';
import ResultSummary from '../../components/shared/result-summary.vue';

export default {
    components: {
        AppLoader, FormInput, ResultSummary
    },
    props: ['order'],
    data: function () {
        return {
            responded: false,
            loading: false,
            result_error: '',
        };
    },
    watch: {
        'order': function (pre, after) {
            if (pre && after && pre.booking_number != after.booking_number) {
                this.responded = false;
            }
        }
    },
    computed: {
        ...mapGetters('globalization', [
            'app_locale',
            'locale',
        ])
    },
    created: function () {
        this.orderService = new OrderService()
        this.emailService = new EmailService()
    },
    methods: {
        getDateString: function (locale, source, format) { return new Date(source).toLocaleString(locale, { dateStyle: format }); },
        getLocalTimeString: function (locale, source) { return new Date(source.substr(0, 19) + 'Z').toLocaleString('no-NO', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Oslo' }); },
        getLocalDateString: function (locale, source, format) { return new Date(source.substr(0, 19) + 'Z').toLocaleString(locale, { dateStyle: format, timeZone: 'Europe/Oslo' }); },
        formatNumber: function (locale, source) { return Number(source).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
        getWeekday: function (locale, source) { return new Date(source).toLocaleString(locale, { weekday: 'long' }); },
        ableToCancel: function (leg) {
            let result = leg.status != 'cancelled' && leg.steps.some(s => s.travel_mode == 'transit' && new Date(s.transit.depart_at.substring(0, 19) + 'Z') > new Date((new Date().toISOString()).substring(0, 19) + 'Z'))
            return result;
        },
        cancelBooking: async function () {
            this.result_error = '';
            if (this.order && this.order.legs.filter(l => l.selected).length > 0) {
                if (this.order.legs.filter(l => l.selected).some(leg => !this.ableToCancel(leg))) {
                    this.result_error = this.$t('pages.cancellation.error_cancellation_time_passed');
                    this.responded = true;
                }
                else {
                    if (this.order.legs.filter(l => l.selected).length == this.order.legs.filter(l=>l.status!='cancelled').length) {
                        this.loading = true;
                        try {
                            let newOrder = await this.orderService.cancel(this.order.id, this.order.token)
                            this.responded = true;
                            this.$emit('cancelled', newOrder);
                            this.order = newOrder;
                            try {
                                await this.emailService.sendOrderCancellationEmail(this.order.id, this.order.token)
                            }
                            catch (ex) {
                                console.log(ex);
                                this.result_error = this.$t('pages.cancellation.email_send_failed')
                            }
                        }
                        catch (err) {
                            this.responded = true

                            if ( err.error_code == 'cancellation_time_passed') {
                                this.result_error = this.$t('pages.cancellation.error_cancellation_time_passed')
                            }
                            else {
                                this.result_error = this.$t('pages.cancellation.failed')
                            }
                        }
                        finally {
                            this.loading = false
                        }
                    }
                    else {
                        this.loading = true
                        try {
                            let newOrder = await this.orderService.cancelLeg(this.order.id, this.order.legs.filter(l => l.selected)[0].id, {
                                app_data: this.order.app_data,
                                roundtrip: false
                            }, this.order.token)

                            this.responded = true
                            this.$emit('cancelled', newOrder);
                            this.order = newOrder;

                            try {
                                await this.emailService.sendLegCancellationEmail(this.order.id, this.order.token)
                            }
                            catch (ex) {
                                console.log(ex);
                                this.result_error = this.$t('pages.cancellation.email_send_failed')
                            }

                        }
                        catch (err) {
                            this.responded = true

                            if (err.error_code == 'cancellation_time_passed') {
                                this.result_error = this.$t('pages.cancellation.error_cancellation_time_passed')
                            }
                            else {
                                this.result_error = this.$t('pages.cancellation.failed')
                            }
                        }
                        finally {
                            this.loading = false
                        }
                    }
                }
            }
            else {
                this.result_error = this.$t('pages.cancellation.error_trip_selection')
            }
        },
    }
}
</script>
<style lang="sass">
</style>
